import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function AlertDialog(props) {
  return (
    <div>
      <Dialog
        open={props.open}
        // onClose={() => props.handle(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"View Details?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your user profile needs to be updated to be able to add or interact
            with the items. Please update your profile by clicking below.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.handle(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              // props.tab("2");
              props.handle(false);
              props.addupdate(true);
            }}
            color="primary"
            autoFocus
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
